import React from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
// Material Ui
import { AppBar, Box, Link, Toolbar, LinearProgress } from "@material-ui/core"
// ## //
import { makeStyles } from "@material-ui/core/styles"
import MainMenu from "./MainMenu"
import UserDropdownMenu from "./UserDropdownMenu"
import useEnvironment from "../../hooks/useEnvironment"

const logo = require("../../styles/img/logo.svg")

const useStyle = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.common.appBar
  }
}))

const Header = () => {
  const location = useLocation()
  const env = useEnvironment()
  const classes = useStyle()

  const isLinearProgressEnabled = useSelector(
    (state) => state.ui.isLinearProgressEnabled
  )

  const isFundPageWithHeadBand = () => {
    return (
      location.pathname.startsWith("/am") ||
      location.pathname.startsWith("/wealth")
    )
  }

  const buildDynamicCSS = () => {
    const defaultStyle = { overflow: "hidden" }
    if (isFundPageWithHeadBand()) {
      return { ...defaultStyle, boxShadow: "none" }
    }
    return defaultStyle
  }

  return (
    <AppBar className={classes.header} style={buildDynamicCSS()}>
      <Toolbar>
        <Box display="flex">
          <Link
            className="header-logo-wrapper"
            href={env.website}
            target="_blank"
            rel="noopener"
          >
            <img src={logo} alt="Webportal main logo" className="header-logo" />
          </Link>
          <MainMenu currentPath="/am" />
        </Box>
        <Box display="flex" alignItems="center">
          <UserDropdownMenu />
        </Box>
      </Toolbar>
      {isLinearProgressEnabled && <LinearProgress color="secondary" />}
    </AppBar>
  )
}

export default Header
